
(ns superadmin.router.core
  (:require [re-frame.core :as rf]
            [superadmin.announcements.view :refer [announcements-page]]
            [superadmin.id-lookup-page.view :refer [id-lookup-page]]
            [superadmin.malware-scans.view :refer [malware-scans-page]]
            [superadmin.os-workspace-editor.view :refer [os-workspaces-page]]
            [superadmin.page.view :refer [superadmin-page]]
            [superadmin.roles.table.view :refer [roles-page]]
            [superadmin.users.details.view :refer [user-details-page]]
            [superadmin.users.table.view :refer [users-page]]))

(def routes
  ["/superadmin" {:controllers [{:identity :data
                                 :start (fn [{:keys [name]}]
                                          (rf/dispatch [:sentry/tag-page-id name]))}]
                  :app :superadmin}
   ["" {:scope :user
        :permissions ["az.cc-superadmin-access"]
        :page-links {"agency" [{:id :agencies
                                :label "Agencies"
                                :icon "settings"
                                :link :superadmin/page}]
                     "users" [{:id :users
                               :label "Users"
                               :icon "people"
                               :link :superadmin/users
                               :enable-flag :superadmin-user-management}]
                     "roles" [{:id :roles
                               :label "Roles"
                               :icon "badge"
                               :link :superadmin/roles
                               :enable-flag :superadmin-user-management}]
                     "wpp os" [{:id :os-workspace-editor
                                :label "Workspace Mappings"
                                :icon "workspaces"
                                :link :superadmin/os-workspace-editor}]
                     "malware" [{:id :malware-scans
                                 :label "Malware Scans"
                                 :icon "pest_control"
                                 :link :superadmin/malware-scans}]
                     "discover" [{:id :id-lookup
                                  :label "Entity Search"
                                  :icon "search"
                                  :link :superadmin/id-lookup}]
                     "announcements" [{:id :announcements
                                       :label "Announcements"
                                       :icon "campaign"
                                       :link :superadmin/announcements}]}}
    ["/announcements" {:name :superadmin/announcements
                       :sub-title "Announcements"
                       :view #'announcements-page}]
    ["/id-lookup" {:name :superadmin/id-lookup
                   :sub-title "Entity Search"
                   :view #'id-lookup-page}]
    ["/os-workspaces" {:name :superadmin/os-workspace-editor
                       :sub-title "Workspaces"
                       :view #'os-workspaces-page}]
    ["/malware-scans" {:name :superadmin/malware-scans
                       :sub-title "Malware scans"
                       :view #'malware-scans-page}]
    ["/users" {:name :superadmin/users
               :sub-title "Users"
               :view #'users-page}]
    ["/users/:user-id" {:name :superadmin/user-detail
                        :sub-title "User Details"
                        :parameters {:path {:user-id string?}}
                        :view #'user-details-page}]
    ["/roles" {:name :superadmin/roles
               :sub-title "Roles"
               :view #'roles-page}]
    ["" {:name :superadmin/page
         :sub-title "Agencies"
         :view #'superadmin-page}]]])
